var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"iframe active",staticStyle:{"width":"100%","height":"100%","background":"#fff"},attrs:{"src":`${_vm.url}`,"frameborder":"no","allowfullscreen":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }